import { render, staticRenderFns } from "./OzPadletLogo.vue?vue&type=template&id=4e758d7c&scoped=true&"
import script from "./OzPadletLogo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzPadletLogo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OzPadletLogo.vue?vue&type=style&index=0&id=4e758d7c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e758d7c",
  null
  
)

export default component.exports